import { getConfig } from '../services/server-url-config/env';
import { getLocale } from '../gs-utils/core/storage/LocaleManager';
export const getAppUrl = (): string => {
  return window.location.origin + window.location.pathname + window.location.hash
};

export const getSSOLoginUrl = (): string => {
  const urlConfig = getConfig();
  return `${urlConfig.apiUrl.apiGatewayPrefix}/gas/api/v1alpha1/sso/login?app=${encodeURIComponent(getAppUrl())}`;
};

export const getSSOLogoutUrl = (): string => {
  const urlConfig = getConfig();
  return `${urlConfig.apiUrl.apiGatewayPrefix}/gas/api/v1alpha1/sso/logout?app=${encodeURIComponent(window.location.origin + window.location.pathname + '&locale=' + getLocale())}`;
};

export const filterXSS = (e: any) => {
  const unescape = window.unescape || window.decodeURI;
  if (!e) return e;
  for (; e !== unescape(e); ) e = unescape(e);
  for (
    let r = ['<', '>', "'", '"', '%3c', '%3e', '%27', '%22', '%253c', '%253e', '%2527', '%2522'],
      n = [
        '&#x3c;',
        '&#x3e;',
        '&#x27;',
        '&#x22;',
        '%26%23x3c%3B',
        '%26%23x3e%3B',
        '%26%23x27%3B',
        '%26%23x22%3B',
        '%2526%2523x3c%253B',
        '%2526%2523x3e%253B',
        '%2526%2523x27%253B',
        '%2526%2523x22%253B',
      ],
      a = 0;
    a < r.length;
    a++
  )
    e = e.replace(new RegExp(r[a], 'gi'), n[a]);
  return e;
};

export const getUrlParams = (url: string, name: string) => {
  const result = url.match(new RegExp(`[\?\&]${name}=([^\&\/]+)`, 'i'));
  if (result === null || result.length < 1) {
    return '';
  }
  return filterXSS(result[1]) || '';
};
